import React from "react";
import { bindActionCreators } from 'redux';
import { executeTaggeo } from "../../store/actions";
import { connect } from 'react-redux';
import { getTelcelLineInformation } from "../../store/actions";
import ClaroParagraph from "../atoms/ClaroParagraph";
import ClaroImage from "../molecules/ClaroImage";
import { getCanShowCanCookiesValue } from "../../store/selectors/paymentsSelectors";
import ModalCardLoader from "../molecules/ModalCardLoader";
import OfferTelcelWithoutLine from "../organisms/OfferTelcelWithoutLine";

const CheckBalanceTelcel = ({
  config, isAnonimous, getTelcelLineInformation, isContainerTelcel,
  lineTelcelInformation, isLoadingGetLineTelcelInformation,
  executeTaggeo, history, userInfo
}) => {

  const [responsePostMessage, setResponsePostMessage] = React.useState(false);
  const [iframeHeight, setIframeHeight] = React.useState("48vh");
  
  const  titleImageStyle =  {
    "align": "center",
    "weight": "bold",
    "margin" : "15px 0px 0px 0px",
    "fontFamily": "AMX-Bold",
    "fontColor": isContainerTelcel ? "#0f0f0f" : "#505050",
  }

  React.useEffect(() => {  
    const { msisdn, tagServiceId } = config
    if (
      (!isAnonimous) ||
      (isAnonimous && msisdn)
    ) { 
      getTelcelLineInformation()
    }
    executeTaggeo(
      {
        action: "View",
        service: tagServiceId,
        step: "Pantalla principal",
        eventName: "telcel"
      }
    );
  }, []);

  const onRecievedMessage = (ev) => {
    const {messageType, informacionData} = ev.data;
    if (
        messageType === "informacion" &&
        ( 
          informacionData.mensaje === "exito" || 
          informacionData.mensaje === "vacio" ||
          informacionData.mensaje === "error" 
        )
    ){
      setResponsePostMessage(true)
      switch (informacionData.mensaje) {
        case "exito":
          setIframeHeight("48vh")
          break;
        case "vacio":
          setIframeHeight("48vh")
          break;
        case "error":
          setIframeHeight("30vh")
          break;
        default:
          break;
      }
    }
  }

  React.useEffect(() => {
    if(!responsePostMessage){
      window.addEventListener(
        "message",
        onRecievedMessage
      );
      return () => {
        window.removeEventListener("message", onRecievedMessage);
      };
    }
  });
  const { generic: {logo}, info, offerTelcel, offerTelcelAnonimo } = config.services[0].serviceData
  const { msisdn } = userInfo
  return (
    <div style={{overflow:"scroll"}}>
      <ClaroParagraph {...titleImageStyle} >
        {info.serviceTitleLabel}
      </ClaroParagraph>
      <ClaroImage {...logo.data} /> 
      { lineTelcelInformation && lineTelcelInformation.urlIframe 
        ?<iframe
          src={`${lineTelcelInformation.urlIframe}?msisdn=${msisdn.replace(/^\+52/, '')}`}
          id="frameTelcel"
          style={{ border: "none", height: !isContainerTelcel ? iframeHeight : "350px", width: "100%" }}
        >
          "No es posible visualizar el contenido"
        </iframe>
        : null
      }
      <ModalCardLoader isOpen={isLoadingGetLineTelcelInformation && !lineTelcelInformation} />
      { !isLoadingGetLineTelcelInformation && lineTelcelInformation ?
        <OfferTelcelWithoutLine
          offerTelcel={!isAnonimous ? offerTelcel : offerTelcelAnonimo}
          planType={"Otro carrier"}
          history={history}
          subtitleAlign={"left"}
          subtitleMargin={"5% 0% 2% 5%"}
          logoIsVisible={"none"}
          subtitle={"Elige una opción"}
          isContainerTelcel={isContainerTelcel}
        /> : <></>
      }
    </div>
    
  );
};

const mapStateToProps = (state) => {
  const { payments: 
    {
      PAYMENT_SERVICE_CONF, isAnonimous, 
      lineTelcelInformation, isLoadingGetLineTelcelInformation,
      userInfo
    } 
  } = state;
  return {
    config : PAYMENT_SERVICE_CONF,
    lineTelcelInformation,
    isAnonimous,
    isLoadingGetLineTelcelInformation,
    userInfo
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      executeTaggeo,
      getTelcelLineInformation
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckBalanceTelcel)
